import { VFC } from 'react'
import { _messageformborder } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'
import { Button, ButtonsDiv } from '../Modals/styles'

export { MessageUnhiddenForm }

export type MessageUnhiddenFormProps = {
  unhiddenRoom: VoidFunction
  className?: string
}
const MessageUnhiddenFormComponent: VFC<MessageUnhiddenFormProps> = ({
  unhiddenRoom,
  className,
}) => {
  return (
    <MessageFormDiv className={className}>
      <h3>非表示中のルームにはメッセージを送信できません</h3>
      <p>メッセージを送る場合は「一覧に戻す」をご選択ください</p>
      <ButtonsDiv>
        <Button onClick={unhiddenRoom}>一覧に戻す</Button>
      </ButtonsDiv>
    </MessageFormDiv>
  )
}
const MessageUnhiddenForm = styled(MessageUnhiddenFormComponent)``

const MessageFormDiv = styled.div`
  border: 1px solid ${_messageformborder};
  border-radius: 5px;

  background-color: #ffffffc0;
  backdrop-filter: blur(50px) brightness(1.75);
  padding: 14px 8px 8px 24px;
  h3 {
    font-weight: ${fontWeightBold};
    font-size: 18px;
    margin-bottom: 16px;
  }
`
